<script setup lang="ts">
import { useUserStore } from '@/stores/modules/user'
import type { UserInfoType } from '@/types/user'
import { socketEmitAsync } from '@/utils/web-socket'
import { Edit, Rank } from '@element-plus/icons-vue'
import { VueDraggable } from 'vue-draggable-plus'

const userStore = useUserStore()

async function handleChangeRoutine(id: number) {
  const userAttr = await socketEmitAsync<UserInfoType['userAttr']>({ type: 'useEquipRoutine', data: { id } })
  userStore.handleChangeEquipRoutine(userAttr, id)
}
async function handleNameRoutine(id: number) {
  const routine = userStore.equippedRoutineList.find((item) => item.id === id)
  if (!routine) return
  ElMessageBox.prompt('请输入装备套路名称', '修改装备套路名称', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    inputPattern: /^[\u4e00-\u9fa5a-zA-Z0-9]{1,8}$/,
    inputValue: routine.name,
    inputErrorMessage: '套路命名在1~8字，且只允许中英文及数字',
    confirmButtonClass: 'is-plain',
    async beforeClose(action, instance, done) {
      if (action !== 'confirm') return done()
      try {
        instance.confirmButtonLoading = true
        instance.confirmButtonText = '加载中...'
        const value = instance.inputValue
        await socketEmitAsync({ type: 'nameEquipRoutine', data: { id, name: value } })
        routine.name = value
        done()
      } finally {
        instance.confirmButtonLoading = false
        instance.confirmButtonText = '确定'
      }
    },
  })
}
async function onDragEnd() {
  const idList = userStore.equippedRoutineList.map((item) => item.id)
  await socketEmitAsync({ type: 'sortEquipRoutine', data: { idList } })
  ElMessage.success('排序成功')
}
</script>

<template>
  <el-select size="small" v-model="userStore.equippedRoutineId" style="margin-top: 10px" @change="handleChangeRoutine">
    <VueDraggable v-model="userStore.equippedRoutineList" :animation="150" handle=".drag-handle" @end="onDragEnd">
      <el-option v-for="item in userStore.equippedRoutineList" :key="item.id" :label="item.name" :value="item.id">
        <div class="routine-option">
          <el-icon class="drag-handle" size="16"><Rank /></el-icon>
          <span class="routine-name">{{ item.name }}</span>
          <el-icon size="16" class="routine-action" @click.stop="handleNameRoutine(item.id)"><Edit /></el-icon>
        </div>
      </el-option>
    </VueDraggable>
  </el-select>
</template>

<style lang="scss" scoped>
.routine-option {
  display: flex;
  align-items: center;
  font-size: 12px;
  gap: 6px;
}
.routine-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.drag-handle {
  cursor: grab;
  color: var(--el-text-color-placeholder);
  touch-action: none;
  &:active {
    cursor: grabbing;
  }
}
.routine-action {
  color: var(--el-text-color-secondary);
  flex-shrink: 0;
}
</style>
